import { useEffect } from 'react';

import { subscribeToHostConsent } from './consent';

/**
 * Null-rendering component that publishes Transcend's consent state as
 * `window.__EB_WEB_CONSENT__` and keeps it current. Mounted in `_app` before
 * `RumInitializer` so the RUM gate sees the real consent state at mount and
 * on every later Transcend `consent-change`/`sync`.
 */
export function HostConsentBridge() {
  useEffect(() => subscribeToHostConsent(), []);

  return null;
}
